import * as React from 'react';
import { UIHeading4 } from '@cian/ui-kit';
import { ProgressBar } from '@cian/frontend-reviews-components';

import * as style from './styles.css';

export interface IRatingDetailProps {
  name: string;
  value: number;
}

export const RatingDetail: React.FC<IRatingDetailProps> = props => {
  const { name, value } = props;

  return (
    <div className={style['container']}>
      <div className={style['label']}>
        <UIHeading4>{name}</UIHeading4>
      </div>
      <div className={style['rating']}>
        <ProgressBar value={value} />
      </div>
    </div>
  );
};
